import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {SchedulesAppccsModelService} from '../../../Models/Tasks/Appccs/schedules-appccs-model.service';
import {ScheduledAppccStoreForm} from '../../../../Models/Tasks/Appccs/Schedules/scheduled-appcc-store.model';

@Injectable({
  providedIn: 'root'
})
export class SchedulesAppccsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: SchedulesAppccsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las programaciones de los appccs
   *
   */
  getSchedulesAppccs(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAppccs', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar una programación
   *
   */
  saveScheduleAppcc(form: ScheduledAppccStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAppcc', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar una programación
   *
   */
  deleteScheduleAppcc(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteAppcc', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar una programación
   *
   */
  toggleScheduleAppcc(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('appccToggleActivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
